(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
   /*
    
       	.state('cluster', {
            parent: 'entity',
            url: '/cluster?page&sort&search',
            data: {
                authenticate: true,
                pageTitle: 'wamasysApp.cluster.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/cluster/clusters.html',
                    controller: 'ClusterController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('cluster');
                    $translatePartialLoader.addPart('etatCluster');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        */
        .state('cluster-detail', {
            parent: 'entity',
            url: '/cluster/{id}?page&sort',
            data: {
                authenticate: true,
                pageTitle: 'wamasysApp.cluster.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/cluster/cluster-detail.html',
                    controller: 'ClusterDetailController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
            	pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('cluster');
                    $translatePartialLoader.addPart('etatCluster');
                    $translatePartialLoader.addPart('individualMeter');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Cluster', function($stateParams, Cluster) {
                    return Cluster.get({id : $stateParams.id});
                }]
            }
        })
        .state('compteur.cluster.new', {
            url: '/new',
            data: {
                authorities: ['ROLE_AREA_MANAGEMENT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/cluster/cluster-dialog.html',
                    controller: 'ClusterDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                numeroSerie: null,
                                dateCreation: null,
                                emplacement: null,
                                etat: null,
                                dateSuppression: null,
                                longitude: null,
                                latitude: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('compteur.cluster', null, { reload: true });
                }, function() {
                    $state.go('compteur.cluster');
                });
            }]
        })
        .state('compteur.cluster.edit', {
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_AREA_MANAGEMENT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/cluster/cluster-dialog.html',
                    controller: 'ClusterDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Cluster', function(Cluster) {
                            return Cluster.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('compteur.cluster', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('compteur.cluster.delete', {
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_AREA_MANAGEMENT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/cluster/cluster-delete-dialog.html',
                    controller: 'ClusterDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Cluster', function(Cluster) {
                            return Cluster.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('compteur.cluster', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
